import { render, staticRenderFns } from "./AboutUs_box1_inner.vue?vue&type=template&id=298a69e4"
import script from "./AboutUs_box1_inner.vue?vue&type=script&lang=js"
export * from "./AboutUs_box1_inner.vue?vue&type=script&lang=js"
import style0 from "./AboutUs_box1_inner.vue?vue&type=style&index=0&id=298a69e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports